export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceDropboxSetting: [
        {
          serviceDropboxId: 2,
          serviceDropboxUuid: "servicedropbox002",
          dropboxName: "スライドショー用",
          dropboxToken: "token-xxxxx-xxxxx-xxx",
          dropboxFolderName: "ila_slideshow",
          dataKbn: 3, 
        }
      ]
    }
  }
}